import React from 'react';
import { m as motion } from 'framer-motion';
import { CheckItem } from './ui/CheckItem';
import { MapaDePistaIcon, Programador12MesesIcon } from './ui/BonoIcons';
import type { BonoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface BonoItemProps {
  bono: BonoContent;
  index: number;
}
export function BonoItem({
  bono,
  index
}: BonoItemProps) {
  const isIconCard = Boolean(bono.icon);
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut,
    delay: index % 4 * 0.05
  }} className={`flex flex-col rounded-2xl border bg-mp-card p-6 ${bono.premiumOnly ? 'border-mp-lime/40' : 'border-mp-border'}`} data-id="element-30" data-mp="1zamzwa8z3t8v">
      {isIconCard && <div className="mb-5 flex h-28 items-center justify-center rounded-xl border border-mp-border bg-mp-dark" data-id="element-31" data-mp="3on70l7dfb7w2">
          {bono.icon === 'mapaDePista' && <MapaDePistaIcon className="h-14 w-14 text-mp-lime" data-id="element-32" data-mp="7v72zxc51guy" />}
          {bono.icon === 'programador12Meses' && <Programador12MesesIcon className="h-14 w-14 text-mp-lime" data-id="element-33" data-mp="2wm2rxwvyx6i" />}
        </div>}

      <div className="flex items-center justify-between gap-2" data-id="element-34" data-mp="gnqw6i9nut8e">
        <span className={`rounded-full border border-mp-lime/40 bg-mp-lime/5 uppercase text-mp-lime font-heading tracking-wide ${isIconCard ? 'px-2.5 py-1 text-[10px]' : 'px-3.5 py-1.5 text-xs'}`} data-id="element-35" data-mp="cngpt4hyi0t0">
          {bono.tag}
        </span>
        {bono.premiumOnly && <span className="font-heading text-[10px] uppercase tracking-wide text-mp-electric" data-id="element-36" data-mp="3u481rd8nubh1">Solo Kit</span>}
      </div>

      <h3 className={`mt-3 font-heading uppercase leading-snug text-mp-white ${isIconCard ? 'text-lg' : 'text-xl'}`} data-id="element-37" data-mp="3p3u3uo0rwhwq">
        {bono.title}
      </h3>

      <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-38" data-mp="14ewa2rw1jbg2">{bono.oneLiner}</p>

      {bono.bullets && <ul className="mt-4 space-y-2" data-id="element-39" data-mp="21rlhmpkr26o">
          {bono.bullets.map(bullet => <CheckItem key={bullet} data-id="element-40" data-mp="6zjq9hbbiisa">{bullet}</CheckItem>)}
        </ul>}

      {bono.value && <p className="mt-4 text-xs uppercase tracking-wide text-mp-gray/70" data-id="element-41" data-mp="b150sw0dqkzb">Valor: {bono.value}</p>}
      {bono.note && <p className="mt-2 text-xs leading-relaxed text-mp-gray/70" data-id="element-42" data-mp="g0zmml5askdi">{bono.note}</p>}
    </motion.div>;
}